import { useState } from 'react';

import Select from 'react-select';

import ErrorMessage from '../../../../../Components/Errors/ErrorMessage';
import Loading from '../../../../../Components/Loading/Loading';
import { useToast } from '../../../../../Hooks/Toast';
import GymModal from './GymModal';

const UsersList = ({
  context,
  loading,
  setModalRemoveObject,
  setModalIsOpen,
  errors,
}) => {
  const { error } = useToast();
  const [zModalIsOpen, setZModalIsOpen] = useState(false);
  const [userModalObject, setUserModalObject] = useState({});

  const editUser = (name, value, userId) => {
    const users = context.users;
    let user = users?.find((u) => u.id === userId);
    // if (name === "age_id") {
    //   let age = context?.competition?.ages?.find((a) => a.id == value);
    //   let range = moment(user?.birthday).isBetween(
    //     moment(age?.start_age),
    //     moment(age?.end_age),
    //   );
    //   if (!range)
    //     return error("رده سنی انتخاب شده با رده سنی شرکت کننده یکسان نیست");
    // }
    user[name] = value;
    context.users = users;
  };
  const addGymToUser = () => {
    const users = [...context.users];
    let user = users.findIndex((u) => u.id === userModalObject?.id);
    users[user]['gym'] = context?.gym;
    context.users = users;
    context.gym = {};
    setZModalIsOpen(false);
  };
  return (
    <>
      <div className='col-12 my-3 custom-overflow'>
        <div className='d-flex flex-row align-items-center my-3'>
          <i className='far fa-users f-18 text-dark'></i>
          <span className='text-dark f-14 font-weight-bold mx-2'>
            لیست شرکت کنندگان انفرادی
          </span>
        </div>
        {loading ? (
          <Loading />
        ) : (
          <>
            {context?.users?.length > 0 ? (
              <table
                className='table table-striped my-3 text-left'
                style={{ minWidth: '992px' }}
              >
                <thead>
                  <tr className='bg-purple text-white'>
                    <th scope='col'>#</th>
                    <th scope='col'>نام و نام خانوادگی</th>
                    <th scope='col'>کد ملی</th>
                    <th scope='col'>استان محل زندگی</th>
                    <th scope='col'>زورخانه</th>
                    <th scope='col'>رشته</th>
                    {context.competition?.weights?.length > 0 && (
                      <th scope='col'>وزن</th>
                    )}
                    <th scope='col'>رده سنی</th>
                    <th scope='col'>حذف</th>
                  </tr>
                </thead>
                <tbody>
                  {context?.users?.map((user, index) => (
                    <tr key={'users-' + user?.id}>
                      <th scope='row'>{index + 1}</th>
                      <td>
                        {user?.name} {user?.last_name}
                      </td>
                      <td>{user?.national_card_id}</td>
                      <td>{user?.province_living?.name}</td>
                      <td>
                        <div className='d-flex flex-row align-items-center justify-content-between'>
                          <span className='text-dark f-13 mt-1'>
                            {user?.gym?.name ?? 'زور خانه ای ثبت نشده'}
                          </span>
                          <i
                            onClick={() => {
                              setUserModalObject(user);
                              setZModalIsOpen(true);
                            }}
                            className='far fa-edit text-info f-16 mx-2 c-pointer'
                            title='اضافه یا ویرایش زورخانه'
                          ></i>
                        </div>
                        <ErrorMessage
                          error={
                            errors?.single?.userErrors?.[`user.gym.${user?.id}`]
                          }
                        />
                      </td>
                      <td>
                        {/* <select
                          defaultValue={user?.sport_id}
                          className='form-control'
                          onChange={(e) =>
                            editUser("sport_id", e.target.value, user?.id)
                          }
                        >
                          <option readonly={true}>انتخاب کنید</option>
                          {context?.competition?.sports?.map((sport) => (
                            <option value={sport.id}>{sport?.title}</option>
                          ))}
                        </select> */}
                        <Select
                          defaultValue={user?.sport_id ?? []}
                          isMulti
                          options={context?.competition?.sports?.filter(
                            (s) =>
                              s?.type === 0 ||
                              s?.type === 1 ||
                              s?.type === 4 ||
                              s?.type === 5,
                          )}
                          onChange={(value) => {
                            editUser('sport_id', value, user?.id);
                          }}
                          noOptionsMessage={() =>
                            `رشته ای جهت انتخاب یافت نشد!`
                          }
                          isOptionDisabled={() =>
                            context.users?.find((u) => u.id == user?.id)
                              ?.sport_id?.length >=
                            context?.competition?.sport_count_select
                          }
                          getOptionLabel={(s) => s?.title}
                          getOptionValue={(s) => s?.id}
                          closeMenuOnSelect={false}
                          classNamePrefix='text-left justify-content-start w-100'
                          placeholder='انتخاب کنید...'
                        />
                        <ErrorMessage
                          error={
                            errors?.single?.userErrors?.[
                              `user.sport_id.${user?.id}`
                            ]
                          }
                        />
                      </td>
                      {context.competition?.weights?.length > 0 && (
                        <td>
                          <select
                            className='form-control'
                            defaultValue={user?.weight_id}
                            onChange={(e) =>
                              editUser('weight_id', e.target.value, user?.id)
                            }
                          >
                            <option readonly={true}>انتخاب کنید</option>
                            {context?.competition?.weights?.map((weight) => (
                              <option
                                key={'user-weight-' + weight.id}
                                value={weight.id}
                              >
                                {weight?.weight}
                              </option>
                            ))}
                          </select>
                          <ErrorMessage
                            error={
                              errors?.single?.userErrors?.[
                                `user.weight_id.${user?.id}`
                              ]
                            }
                          />
                        </td>
                      )}
                      <td>
                        <select
                          className='form-control'
                          defaultValue={user?.age_id}
                          onChange={(e) =>
                            editUser('age_id', e.target.value, user?.id)
                          }
                        >
                          <option readonly={true}>انتخاب کنید</option>
                          {context?.competition?.ages?.map((age) => (
                            <option value={age.id}>{age?.title}</option>
                          ))}
                        </select>
                        <ErrorMessage
                          error={
                            errors?.single?.userErrors?.[
                              `user.age_id.${user?.id}`
                            ]
                          }
                        />
                      </td>
                      <td>
                        <i
                          className='fal fa-trash text-danger f-18 c-pointer mt-2'
                          onClick={() => {
                            setModalRemoveObject(user);
                            setModalIsOpen(true);
                          }}
                        ></i>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className='d-flex flex-row justify-content-center align-items-center my-3'>
                اطلاعاتی جهت نمایش یافت نشد.
              </div>
            )}
          </>
        )}
      </div>
      <GymModal
        context={context}
        setZModalIsOpen={setZModalIsOpen}
        zModalIsOpen={zModalIsOpen}
        addGymToUser={addGymToUser}
      />
    </>
  );
};

export default UsersList;
